import { GetUserResponseBody } from "@/api/dto/users"
import clsx from "clsx"
import { CrossOriginImage } from "./CrossOriginImage"
import { isPixiesetAuthEnabled } from "@/utils/measurement/feature-flag"

export type UserProfileSize = "xsmall" | "small" | "medium"
export const UserProfile = (props: { user?: GetUserResponseBody; size: UserProfileSize }) => {
	const profilePictureUrl = props.user?.profilePictureUrl
	const getSize = () => {
		switch (props.size) {
			case "xsmall":
				return "size-8"
			case "small":
				return "size-10"
			case "medium":
				return "size-16"
		}
	}

	const getTextSize = () => {
		switch (props.size) {
			case "xsmall":
				return "text-md"
			case "small":
				return "text-lg"
			case "medium":
				return "text-xxl"
		}
	}
	if (!props.user) {
		return <div></div>
	} else {
		const displayName = isPixiesetAuthEnabled()
			? props.user.businessName?.trim() || props.user.displayName
			: props.user.displayName

		const initial = displayName.charAt(0).toUpperCase()
		return (
			<div className={clsx("shrink-0 overflow-hidden rounded-full", getSize())}>
				{profilePictureUrl && profilePictureUrl.length > 0 && (
					<CrossOriginImage
						src={props.user.profilePictureUrl}
						height={props.size}
						width={props.size}
					/>
				)}
				{(!profilePictureUrl || profilePictureUrl.length == 0) && (
					<div
						className={clsx(
							`flex size-full items-center justify-center bg-base-200 text-base-600`,
							getTextSize(),
						)}
					>
						<span>{initial}</span>
					</div>
				)}
			</div>
		)
	}
}
